import * as React from "react"
import {useEffect} from "react"
import {batch, useComputed, useSignal} from "@preact/signals-react";
import {Box, Collapse, Stack, Typography} from "@mui/material";
import {AlertSeeker, ButtonSeeker} from "@components/ui";


export default function AppWrapperPageNotificationsBlock({ notifications=[], title='', open=true, ...generalConfig }) {
	const numNotifications = notifications.length

	const isOpen = useSignal(open)
	const hideNotification = useSignal([])
	const numHideNotifications = useComputed(() => hideNotification.value.length)
	const openAll = useComputed(() => numNotifications !== numHideNotifications.value && isOpen.value)

	useEffect(() => {
		isOpen.value = !openAll.value ? false : isOpen.value
	}, [openAll.value])

	const handleClick = () => batch(() => {
		hideNotification.value = []
		isOpen.value = !isOpen.value
	})

	return <Box sx={{ width: 1, py: 1 }}>
		<Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ px: 1 }}>
			<Typography variant="title">
				{title}
			</Typography>

			{ <ButtonSeeker onClick={handleClick} sx={{ width: { lg: .2, xl: .1 } }}>
				{ openAll.value ? 'Close All' : 'Open Notifications' }
			</ButtonSeeker> }
		</Stack>

		<Collapse in={openAll.value} sx={{ py: 1 }}>
			{ notifications.map(({ msg, ...config }, idx) => <Collapse key={idx} in={!hideNotification.value.includes(idx)}>
				<AlertSeeker
					severity="warning"
					onClose={()=> hideNotification.value = [idx, ...hideNotification.value]}
					{...generalConfig}
					{...config}
					sx={{ mt: 1, ...config?.sx }}
					disableAccordion
				>
					{msg}
				</AlertSeeker>
			</Collapse>) }
		</Collapse>
	</Box>
}